import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChildren, QueryList, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StatusAutenticacao } from 'src/app/model';
import { LoginService } from 'src/app/services';

@Component({selector: 'app-autenticacao',
    templateUrl: './autenticacao.component.html',
    styleUrls: ['./autenticacao.component.scss'], standalone: false})
export class AutenticacaoComponent implements OnInit {
    @ViewChildren('inputRef') inputRefs!: QueryList<ElementRef>;
    @Output() logado: EventEmitter<string> = new EventEmitter();
    @Output() trocaTelaLogin: EventEmitter<boolean> = new EventEmitter();

    codeArray: string[] = ["", "", "", "", "", ""];
    mensagemErro: string = "";
    previousUrl: string = '';
    // carregando: boolean = false;

    constructor(
        private cdr: ChangeDetectorRef,
        private loginService: LoginService,
        private router: Router,
    ) { }

    ngOnInit() {
        history.pushState(null, null, window.location.href);
        window.onpopstate = () => {
            history.pushState(null, null, window.location.href);
        };
    }

    trackByIndex(index: number, item: any): number {
        return index; // Retorna o índice como identificador único
    }

    onInput(event: Event, index: number) {
        const target = event.target as HTMLInputElement;
        const value = target.value;

        // Apenas permita números e apenas um dígito
        if (value && !isNaN(Number(value)) && value.length === 1) {
            this.codeArray[index] = value; // Atualiza o valor no array

            // Move o foco para o próximo input se ainda houver mais inputs
            if (index < this.inputRefs.length - 1) {
                this.inputRefs.toArray()[index + 1].nativeElement.focus();
                this.cdr.detectChanges();
            }

            if (index === this.inputRefs.length - 1) {
                this.enviarCodigo();
            }
        } else {
            // Limpa o input se o valor não for válido
            this.codeArray[index] = '';
            target.value = '';
            this.cdr.detectChanges();
        }
    }

    onKeydown(event: KeyboardEvent, index: number) {
        const target = event.target as HTMLInputElement;

        // Se a tecla Backspace for pressionada e o input estiver vazio, vai para o input anterior
        if (event.key === 'Backspace' && !target.value && index > 0) {
            const prevInput = this.inputRefs.toArray()[index - 1].nativeElement;
            prevInput.focus();
        }
    }

    onPaste(event: ClipboardEvent) {
        // Obtém os dados do clipboard
        const clipboardData = event.clipboardData;
        const pastedText = clipboardData.getData('text') || '';

        // Verifica se o texto colado contém apenas números
        if (!/^\d+$/.test(pastedText)) {
            event.preventDefault();
            return;
        }

        // Preenche os inputs com os números colados
        for (let i = 0; i < this.codeArray.length && i < pastedText.length; i++) {
            this.codeArray[i] = pastedText[i];

            // Atualiza o valor do input e move o foco para o próximo
            this.inputRefs.toArray()[i].nativeElement.value = pastedText[i];

            if (i < this.inputRefs.length - 1) {
                this.inputRefs.toArray()[i + 1].nativeElement.focus();
            }
        }

        // Evita o comportamento padrão do evento de colar
        if (this.codeArray.length === pastedText.length) {
            this.enviarCodigo();
        }
        event.preventDefault();
    }

    enviarCodigo() {
        this.loginService.verificarCodigoAutenticacao(this.codeArray.join("")).subscribe(
            (dados) => {
                if (dados.Status === StatusAutenticacao.SUCESSO) {
                    this.logado.emit("logado");
                } else if (dados.Status === StatusAutenticacao.ERRO) {
                    this.mensagemErro = "Erro ao verificar o código";
                } else {
                    this.mensagemErro = `O código inserido ${dados.Status === StatusAutenticacao.RECUSADO ? 'é inválido!' : 'expirou!'}`;
                }
            },
            (err) => {
                this.mensagemErro = "Erro ao verificar o código";
                console.error('Error verifying code:', err);
            }
        );
    }

    refazerLogin() {
        this.loginService.clearTempUser();
        this.loginService.clearFingerPrint();

        this.trocaTelaLogin.emit(true);
    }

    ngOnDestroy(): void {
        // Limpa o código ao sair do componente
        this.codeArray = ["", "", "", "", "", ""];
        this.loginService.clearTempUser();
    }
}
